import FaultTreeMxGraph from 'hcl-web-editor/app/mxGraph/HCLTreeMxGraph/FaultTreeMxGraph';

class PhoenixEditorFaultTreeMxGraph extends FaultTreeMxGraph {
  private _idsVisible: boolean = false;

  public getIDsVisible(): boolean {
    return this._idsVisible;
  }

  public setIDsVisible(visible: boolean): void {
    this._idsVisible = visible;
    this.refresh(null);
  }
}

export default PhoenixEditorFaultTreeMxGraph;
